import React from "react";
import { css } from "@emotion/react";
import { NoImageSvg } from "../../assets";
import { SimpleAspectRatio } from "../../components/_shared-components/SimpleAspectRatio";
import { useGeneralTranslationsContext } from "../../global/hooks/use-general-translations-context";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { PdpGalleryWithLightboxProps } from "./PDP_Lightbox/use-pdp-gallery-with-lightbox";
import { PDPAboveTheFoldMainImageDesktop } from "./PDPAboveTheFoldMainImageDesktop";
import { PDPAboveTheFoldMainImageMobile } from "./PDPAboveTheFoldMainImageMobile";

export const PDPAboveTheFoldMainImage: ReactTFC<{
  galleryWithLightbox: PdpGalleryWithLightboxProps;
  ribbonTextElement: React.ReactElement;
}> = props => {
  const noImage = useGeneralTranslationsContext()("noImage");

  const NoImage = (
    <SimpleAspectRatio
      as={"div"}
      allChildren={true}
      className={"js-pdp-above-the-fold-main-image--no-image"}
      css={css`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 8px;

        background: ${CSS_COLORS.GreenWhite};

        position: relative;
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;

          color: ${CSS_COLORS.GrayDark2024};
        `}
      >
        <NoImageSvg strokeWidth={2} aria-label={noImage.value} />
      </div>

      {props.ribbonTextElement}
    </SimpleAspectRatio>
  );

  if (!props.galleryWithLightbox) {
    return NoImage;
  }

  const {
    galleryConfig: { primaryImage, scrollingGalleryElements },
    openModal,
  } = props.galleryWithLightbox;

  if (!primaryImage) {
    return NoImage;
  }

  return (
    <>
      <PDPAboveTheFoldMainImageMobile
        openModal={openModal}
        primaryImage={primaryImage}
        scrollingGalleryElements={scrollingGalleryElements}
      >
        {props.ribbonTextElement}
      </PDPAboveTheFoldMainImageMobile>
      <PDPAboveTheFoldMainImageDesktop openModal={openModal} primaryImage={primaryImage}>
        {props.ribbonTextElement}
      </PDPAboveTheFoldMainImageDesktop>
    </>
  );
};
